import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { blueGrey } from '@material-ui/core/colors';

const Image = styled.img`
  height: 80px;
  object-fit: contain;
`;

const Title = styled.span`
  font-size: 24px;
  margin-top: 27px;
  font-weight: bold;
  line-height: 28px;
  text-align: center;
  color: ${blueGrey[900]};
`;

const Description = styled.span`
  font-size: 16px;
  margin-top: 16px;
  font-weight: 300;
  line-height: 21px;
  text-align: center;
  color: ${blueGrey[900]};
`;

const Root = styled.div`
  margin: 1em;
  width: 400px;
  padding: 2em;
  height: 300px;
  display: flex;
  position: relative;
  align-items: center;
  flex-direction: column;
  transition: all 0.17s ease-in-out;

  &:hover {
    transform: scale(1.15);
    background-color: white;
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.1);
  }
`;

function Box({ title, image, description }) {
  return (
    <Root>
      <Image src={image} />
      <Title>{title}</Title>
      <Description>{description}</Description>
    </Root>
  );
}

Box.propTypes = {
  title: PropTypes.string.isRequired,
  image: PropTypes.string.isRequired,
  description: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
    PropTypes.string,
  ]).isRequired,
};

Box.defaultProps = {};

export default Box;
